///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ProductsTabs } from '../../../entities/products-page/products-tabs.enum';
import { ProjectProductsService } from '../../../project-view-panel/logical-topology/engine/project-products-service';
import { ProductTypeEnum } from '../../../generated/shared-types.model';

@Directive({
    selector: '[windeProductNameLink]',
    standalone: false
})
export class GtthProductNameLinkDirective implements OnInit, OnChanges {
    @Input('windeProductNameLink') productName: string;
    @Input() outerLink: string;
    @Input() isUseInfoButton = false;

    private readonly element;
    private linkUrl: string;

    constructor(
        el: ElementRef,
        private readonly projectProductsService: ProjectProductsService
    ) {
        this.element = el.nativeElement;
    }

    public static getMHProductLink(productName: string): string {
        return `./#/products?product_type=${ProductsTabs.MH_PARTS}&product_name=${productName}`;
    }

    ngOnInit(): void {
        this.createLinkUrl();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.productName?.firstChange && changes.productName?.currentValue !== changes.productName?.previousValue) {
            this.productName = changes.productName.currentValue;
            this.createLinkUrl();
        }
        if (!changes.outerLink?.firstChange && changes.outerLink?.currentValue !== changes.outerLink?.previousValue) {
            this.outerLink = changes.outerLink.currentValue;
            this.createLinkUrl();
        }
    }

    private createLinkUrl(): void {
        this.linkUrl = '';
        if (this.outerLink) {
            this.linkUrl = this.outerLink;
        } else if (this.productName) {
            const radio = this.projectProductsService.getRadioByName(this.productName);
            if (radio) {
                let partType: ProductsTabs;
                switch (radio.productType) {
                    case ProductTypeEnum.EH:
                        partType = ProductsTabs.EH_PARTS;
                        break;
                    case ProductTypeEnum.MH:
                        partType = ProductsTabs.MH_PARTS;
                        break;
                    case ProductTypeEnum.TG_MH:
                        partType = ProductsTabs.TG_MH_PARTS;
                        break;
                }
                this.linkUrl = `./#/products?product_type=${partType}&product_name=${this.productName}`;
            }
        }
        if (this.linkUrl) {
            this.createLinkElement();
        } else {
            this.removeLinkElement();
        }
    }

    private createLinkElement(): void {
        if (this.isUseInfoButton) {
            if (this.element.children.length) {
                const link = this.element.children[0];
                link.setAttribute('href', this.linkUrl);
            } else {
                const a = document.createElement('a');
                a.setAttribute('href', this.linkUrl);
                a.setAttribute('target', '_blank');
                a.innerHTML = `<span style="font-weight: bold;">&#9432;</span>`;
                this.element.appendChild(a);
            }
        } else {
            this.element.innerHTML = `<a href="${this.linkUrl}" class="btn--product-link" target="_blank">${this.productName}</a>`;
        }
    }

    private removeLinkElement(): void {
        if (this.element.children.length) {
            this.element.removeChild(this.element.firstChild);
            this.element.innerHTML = this.productName;
        }
    }
}
